module.exports = __webpack_public_path__ + "img/IMG_2399_T_L.f34667d8.webp";